import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Tab from 'react/containers/layout/tabs/Tab';
import { Flex } from 'onefaceui-react-components';
import { DriverList } from 'react/components/QuickAssignment/DriverList';
import { RouteList } from 'react/components/QuickAssignment/RouteList';
import { EquipmentList } from 'react/components/QuickAssignment/EquipmentList';
import { RouteFilter } from 'react/components/QuickAssignment/RouteFilter';
import useRouteFilter from 'react/components/QuickAssignment/hooks/useRouteFilter.hook';

function SpeedAssignmentComponent() {
  const filterState = useRouteFilter();
  const [isFilterExpanded, setIsFilterExpanded] = useState(false);

  const handleExpandChange = (expanded) => {
    setIsFilterExpanded(expanded);
  };

  const contentHeight = isFilterExpanded
    ? 'calc(100% - 145px)'
    : 'calc(100% - 32px)';

  return (
    <div id="SpeedAssignment">
      <RouteFilter
        filterState={filterState}
        onExpandChange={handleExpandChange}
      />
      <Flex style={{ height: contentHeight }}>
        <DriverList />
        <RouteList filterState={filterState} />
        <EquipmentList />
      </Flex>
    </div>
  );
}

class SpeedAssignment extends Tab {
  render() {
    const { active, updateTitle, tab } = this.props;
    const { key } = tab;

    updateTitle({
      key,
      title: Monet.I18n.getResourcesByKey('Greenmile.speedAssigment.tabTitle')
    });

    const className = `gmTabs__panel ${active ? 'is-active' : ''}`;

    return (
      <div className={className}>
        <SpeedAssignmentComponent />
      </div>
    );
  }
}

SpeedAssignment.propTypes = {
  active: PropTypes.bool,
  tab: PropTypes.object,
  updateTitle: PropTypes.func
};

SpeedAssignment.defaultProps = {
  active: false,
  tab: {},
  updateTitle: () => null
};

export default SpeedAssignment;
